export default __webpack_public_path__ + "static/bussinessSuccess-180381669875be1fd92d50aed1fe3aab.png";